import { TranslocoService } from '@jsverse/transloco';
import { lastValueFrom, of } from 'rxjs';
import { UserConfigService } from './services/user-config.service';

/**
 * A factory function returning a promise to preload the languages assets
 * before starting the Angular app, used as an APP_INITIALIZER provider
 * @param translocoService used to set active language and load language asset
 * @returns a promise resolving the translation asset.
 */
export const preloadLanguage = (translocoService: TranslocoService) => {
  const regex = /language\/([^\\/?\s]+)/;
  const match = window.location.href.match(regex);
  let language = 'engb';
  if (match?.[1] !== undefined) {
    language = match[1];
  }
  translocoService.setActiveLang(language);
  return lastValueFrom(translocoService.load(language));
};

export const initializeEnvironmentConfig = (
  userConfigService: UserConfigService
) => {
  const url = window.location.href.toLowerCase();
  const isCn = url.includes('agridencecn');
  console.log('initializeEnvironmentConfig', url, isCn);
  if (isCn) {
    userConfigService.setCnEnvironmentConfig();
  }
  return of(true);
};
